import React from 'react'
import './styles.css'

const Home = () =>{
    return(
      <div className="espaco-cultural">
        <div id="bg-cultural">
        <div id="card">
          A Prefeitura de Itanhaém, por meio da Secretaria de Educação, Cultura e Esportes, torna público o presente Chamamento para Cadastro de Trabalhadores e Trabalhadoras da Cultura residentes em Itanhaém, Espaços Culturais e Artísticos, Microempresas e Pequenas Empresas Culturais, Organizações Culturais Comunitárias e Cooperativas e Instituições Culturais sediadas no município para fomento à Cultura.
          <a href="http://gg.gg/trabalhadorxs">Trabalhador(a) da Cultura</a>
          <a href="http://gg.gg/espacosculturais">Espaço Cultural</a>
        </div>
      </div>
      </div>
    )
}

export default Home